import { render, staticRenderFns } from "./ClaimerForm.vue?vue&type=template&id=f8f9ecba&scoped=true"
import script from "./ClaimerForm.ts?vue&type=script&lang=ts&external"
export * from "./ClaimerForm.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f9ecba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8f9ecba')) {
      api.createRecord('f8f9ecba', component.options)
    } else {
      api.reload('f8f9ecba', component.options)
    }
    module.hot.accept("./ClaimerForm.vue?vue&type=template&id=f8f9ecba&scoped=true", function () {
      api.rerender('f8f9ecba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/components/P48/ClaimerForm/ClaimerForm.vue"
export default component.exports